import Cookies from 'js-cookie'; //https://github.com/js-cookie/js-cookie

export default class {

    constructor() {
        this.cookieName = 'roadblock';
        this.breakpoint = 1026;
        this.modalWrapper = $('.roadblock-modalwrapper');
        this.modal = this.modalWrapper.find('.roadblock');
        this.closeButton = this.modal.find('.roadblock-closebutton');

        this.clickEvents();
        this.showRoadblock();
        this.setBodyTopMargin();

        $(window).on('resize', () => this.setBodyTopMargin());
    }

    setBodyTopMargin() {
        if ($(window).width() >= this.breakpoint) {
            const availableHeight = $('.roadblock-imagewrapper').height();
            const contentHeight = $('.roadblock-bodywrapper').height();            
            const paddingTop = contentHeight < availableHeight ? (availableHeight - contentHeight) / 2 : 0;
            $('.roadblock-bodywrapper').css('padding-top', paddingTop);
        } else {
            $('.roadblock-bodywrapper').css('padding-top', 0);
        }    
    }

    clickEvents() {
        this.closeButton.on('click', () => this.dismissRoadblock());
        $('#RoadblockDismissButton').on('click', () => this.dismissRoadblock());
    }

    getExpiry() {
        switch (this.modalWrapper.data('persistence')) {
            case 'Show every 24hrs': return { expires: 1 };
            case 'Show every 7days': return { expires: 7 };
            default: return {};
        }
    }

    dismissRoadblock() {
        this.setCookie(this.cookieName, 'dismissed', this.getExpiry());
        this.modalWrapper.hide();
        $(document).off('keydown.modalFocusTrap');
        $('body').css('overflow', '');
    }

    showRoadblock() {
        if (!this.getCookie(this.cookieName)) {
            this.modalWrapper.show();
            this.modal.removeAttr('hidden');
            this.modal.attr('aria-hidden', 'false');
            this.trapFocus();
            $('body').css('overflow', 'hidden');
        }        
    }

    trapFocus() {
        $(document).on('keydown.modalFocusTrap', (e) => {
            const focusable = this.modal.find('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])').toArray();
            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }

            if (e.key === 'Escape') {
                e.preventDefault();
                this.dismissRoadblock();
            }
        });
    }

    setCookie(name, value, settings) {        
        Cookies.set(name, value, settings);
    }

    getCookie(name) {
        return Cookies.get(name);
    }
}
